import { createSelector, createSlice } from '@reduxjs/toolkit'

const initialState = {
  recordingRequested: null,
  orderId: null,
  intentId: 0,
  fileIdentifier: null,
  // Status of the active session only; it travels in the label payload.
  lastStatus: null,
  // Latest event from any session, including one the packer already left, so
  // a late upload failure still reaches the operator.
  lastEvent: null,
  lastEventId: 0,
  startedAt: null,
}

export const webcamRecorderSlice = createSlice({
  name: 'webcamRecorder',
  initialState,
  reducers: {
    requestRecording: (state, action) => {
      state.recordingRequested = true
      state.orderId = action.payload
      state.intentId += 1
      state.fileIdentifier = null
      state.startedAt = null
      state.lastStatus = null
    },
    recordingStarted: (state, action) => {
      const { intentId, fileIdentifier, startedAt } = action.payload
      if (intentId !== state.intentId) return
      state.fileIdentifier = fileIdentifier
      state.startedAt = startedAt
    },
    setLastStatus: (state, action) => {
      const { intentId, status } = action.payload
      if (intentId !== state.intentId) return
      state.lastStatus = status
    },
    setLastEvent: (state, action) => {
      state.lastEvent = action.payload
      state.lastEventId += 1
    },
    stopRecording: (state, action) => {
      const intentId = action.payload?.intentId
      if (intentId !== undefined && intentId !== state.intentId) return
      state.recordingRequested = false
      state.startedAt = null
    },
  },
})

export const { requestRecording, recordingStarted, setLastStatus, setLastEvent, stopRecording } = webcamRecorderSlice.actions

export const recordingRequested = state => state.webcamRecorder.recordingRequested
export const orderId = state => state.webcamRecorder.orderId
export const intentId = state => state.webcamRecorder.intentId
export const fileIdentifier = state => state.webcamRecorder.fileIdentifier
export const lastStatus = state => state.webcamRecorder.lastStatus
export const lastEvent = state => state.webcamRecorder.lastEvent
export const lastEventId = state => state.webcamRecorder.lastEventId
export const startedAt = state => state.webcamRecorder.startedAt

export const selectCameraSnapshot = createSelector([startedAt, fileIdentifier, lastStatus], (started, key, status) => ({
  recording: started !== null,
  file_identifier: key,
  status,
  started_at: started,
}))

export default webcamRecorderSlice.reducer
